// src/utils/svDepartamentos.js
// All 14 El Salvador departments with their Boxful stateId and municipios with cityId.
// Used by the Nueva Caja form for cascading dropdowns.
// Used by the boxful-address and boxful-dispatch Edge Functions for ID resolution.
// DO NOT store boxful_state_id or boxful_city_id in the DB — store human-readable
// name strings only. Edge Functions look up IDs from this file at dispatch time.

export const SV_DEPARTAMENTOS = [
  {
    name: "Ahuachapán",
    boxful_state_id: "64a302eae2212e31584a819e",
    municipios: [
      { name: "Ahuachapán",             boxful_city_id: "64a30322e16d1dbcc073b5bd" },
      { name: "Apaneca",                boxful_city_id: "64a30322e16d1dbcc073b5bf" },
      { name: "Atiquizaya",             boxful_city_id: "64a30322e16d1dbcc073b5c0" },
      { name: "Concepción de Ataco",    boxful_city_id: "64a30322e16d1dbcc073b5c1" },
      { name: "El Refugio",             boxful_city_id: "64a30322e16d1dbcc073b5c2" },
      { name: "Guaymango",              boxful_city_id: "64a30323e16d1dbcc073b5c5" },
      { name: "Jujutla",                boxful_city_id: "64a30322e16d1dbcc073b5c3" },
      { name: "San Francisco Menéndez", boxful_city_id: "64a30323e16d1dbcc073b5c4" },
      { name: "San Lorenzo",            boxful_city_id: "64a30323e16d1dbcc073b5c7" },
      { name: "San Pedro Puxtla",       boxful_city_id: "64a30323e16d1dbcc073b5c6" },
      { name: "Tacuba",                 boxful_city_id: "64a30323e16d1dbcc073b5e4" },
      { name: "Turín",                  boxful_city_id: "64a30323e16d1dbcc073b5e5" },
    ],
  },
  {
    name: "Cabañas",
    boxful_state_id: "64a302e9e2212e31584a8197",
    municipios: [
      { name: "Cinquera",      boxful_city_id: "64a30325e16d1dbcc073b68d" },
      { name: "Dolores",       boxful_city_id: "64a30325e16d1dbcc073b68c" },
      { name: "Guacotecti",    boxful_city_id: "64a30325e16d1dbcc073b68f" },
      { name: "Ilobasco",      boxful_city_id: "64a30325e16d1dbcc073b690" },
      { name: "Jutiapa",       boxful_city_id: "64a30325e16d1dbcc073b691" },
      { name: "San Isidro",    boxful_city_id: "64a30325e16d1dbcc073b694" },
      { name: "Sensuntepeque", boxful_city_id: "64a30325e16d1dbcc073b693" },
      { name: "Tejutepeque",   boxful_city_id: "64a30325e16d1dbcc073b695" },
      { name: "Victoria",      boxful_city_id: "64a30325e16d1dbcc073b692" },
    ],
  },
  {
    name: "Chalatenango",
    boxful_state_id: "64a302eae2212e31584a81a1",
    municipios: [
      { name: "Agua Caliente",            boxful_city_id: "64a30325e16d1dbcc073b697" },
      { name: "Arcatao",                  boxful_city_id: "64a30325e16d1dbcc073b698" },
      { name: "Azacualpa",                boxful_city_id: "64a30325e16d1dbcc073b696" },
      { name: "Cancasque",                boxful_city_id: "64a30325e16d1dbcc073b6b3" },
      { name: "Chalatenango",             boxful_city_id: "64a30325e16d1dbcc073b69a" },
      { name: "Citalá",                   boxful_city_id: "64a30325e16d1dbcc073b69c" },
      { name: "Comalapa",                 boxful_city_id: "64a30325e16d1dbcc073b699" },
      { name: "Concepción Quezaltepeque", boxful_city_id: "64a30325e16d1dbcc073b69b" },
      { name: "Dulce Nombre de María",    boxful_city_id: "64a30325e16d1dbcc073b6a2" },
      { name: "El Carrizal",              boxful_city_id: "64a30325e16d1dbcc073b6a3" },
      { name: "El Paraíso",               boxful_city_id: "64a30325e16d1dbcc073b69f" },
      { name: "La Laguna",                boxful_city_id: "64a30325e16d1dbcc073b6a1" },
      { name: "La Palma",                 boxful_city_id: "64a30325e16d1dbcc073b69e" },
      { name: "La Reina",                 boxful_city_id: "64a30325e16d1dbcc073b6a0" },
      { name: "Las Flores",               boxful_city_id: "64a30325e16d1dbcc073b6b6" },
      { name: "Las Vueltas",              boxful_city_id: "64a30325e16d1dbcc073b69d" },
      { name: "Nombre de Jesús",          boxful_city_id: "64a30325e16d1dbcc073b6ab" },
      { name: "Nueva Concepción",         boxful_city_id: "64a30325e16d1dbcc073b6ac" },
      { name: "Nueva Trinidad",           boxful_city_id: "64a30325e16d1dbcc073b6a4" },
      { name: "Ojos de Agua",             boxful_city_id: "64a30325e16d1dbcc073b6a6" },
      { name: "Potonico",                 boxful_city_id: "64a30325e16d1dbcc073b6a5" },
      { name: "San Antonio de la Cruz",   boxful_city_id: "64a30325e16d1dbcc073b6a7" },
      { name: "San Antonio Los Ranchos",  boxful_city_id: "64a30325e16d1dbcc073b6aa" },
      { name: "San Fernando",             boxful_city_id: "64a30325e16d1dbcc073b6a9" },
      { name: "San Francisco Lempa",      boxful_city_id: "64a30325e16d1dbcc073b6ad" },
      { name: "San Francisco Morazán",    boxful_city_id: "64a30325e16d1dbcc073b6a8" },
      { name: "San Ignacio",              boxful_city_id: "64a30325e16d1dbcc073b6b2" },
      { name: "San Isidro Labrador",      boxful_city_id: "64a30325e16d1dbcc073b6b1" },
      { name: "San Luis del Carmen",      boxful_city_id: "64a30325e16d1dbcc073b6b4" },
      { name: "San Miguel de Mercedes",   boxful_city_id: "64a30325e16d1dbcc073b6ae" },
      { name: "San Rafael",               boxful_city_id: "64a30325e16d1dbcc073b6af" },
      { name: "Santa Rita",               boxful_city_id: "64a30325e16d1dbcc073b6b5" },
      { name: "Tejutla",                  boxful_city_id: "64a30325e16d1dbcc073b6b0" },
    ],
  },
  {
    name: "Cuscatlán",
    boxful_state_id: "64a302e9e2212e31584a8198",
    municipios: [
      { name: "Candelaria",              boxful_city_id: "64a30323e16d1dbcc073b5e8" },
      { name: "Cojutepeque",             boxful_city_id: "64a30323e16d1dbcc073b5e6" },
      { name: "El Carmen",               boxful_city_id: "64a30323e16d1dbcc073b5eb" },
      { name: "El Rosario",              boxful_city_id: "64a30323e16d1dbcc073b5ec" },
      { name: "Monte San Juan",          boxful_city_id: "64a30323e16d1dbcc073b5ed" },
      { name: "Oratorio de Concepción",  boxful_city_id: "64a30323e16d1dbcc073b5ee" },
      { name: "San Bartolomé Perulapía", boxful_city_id: "64a30323e16d1dbcc073b5ef" },
      { name: "San Cristóbal",           boxful_city_id: "64a30323e16d1dbcc073b5f0" },
      { name: "San José Guayabal",       boxful_city_id: "64a30323e16d1dbcc073b5e9" },
      { name: "San Pedro Perulapán",     boxful_city_id: "64a30323e16d1dbcc073b5e7" },
      { name: "Santa Cruz Analquito",    boxful_city_id: "64a30323e16d1dbcc073b5f1" },
      { name: "Santa Cruz Michapa",      boxful_city_id: "64a30323e16d1dbcc073b5ea" },
      { name: "Suchitoto",               boxful_city_id: "64a30323e16d1dbcc073b5f2" },
      { name: "San Ramón",               boxful_city_id: "64a30323e16d1dbcc073b5f3" },
    ],
  },
  {
    name: "La Libertad",
    boxful_state_id: "64a302eae2212e31584a819c",
    municipios: [
      { name: "Antiguo Cuscatlán",   boxful_city_id: "64a30324e16d1dbcc073b5f9" },
      { name: "Ciudad Arce",         boxful_city_id: "64a30324e16d1dbcc073b5fa" },
      { name: "Colón",               boxful_city_id: "64a30324e16d1dbcc073b5fb" },
      { name: "Comasagua",           boxful_city_id: "64a30324e16d1dbcc073b5fc" },
      { name: "Huizúcar",            boxful_city_id: "64a30324e16d1dbcc073b5fd" },
      { name: "Jayaque",             boxful_city_id: "64a30324e16d1dbcc073b5fe" },
      { name: "Jicalapa",            boxful_city_id: "64a30324e16d1dbcc073b5ff" },
      { name: "La Libertad",         boxful_city_id: "64a30324e16d1dbcc073b600" },
      { name: "Nuevo Cuscatlán",     boxful_city_id: "64a30324e16d1dbcc073b601" },
      { name: "San Juan Opico",      boxful_city_id: "64a30324e16d1dbcc073b602" },
      { name: "Santa Tecla",         boxful_city_id: "64a30324e16d1dbcc073b5f4" },
      { name: "Quezaltepeque",       boxful_city_id: "64a30324e16d1dbcc073b5f5" },
      { name: "Sacacoyo",            boxful_city_id: "64a30324e16d1dbcc073b5f6" },
      { name: "San Matías",          boxful_city_id: "64a30324e16d1dbcc073b5f7" },
      { name: "San Pablo Tacachico", boxful_city_id: "64a30324e16d1dbcc073b5f8" },
      { name: "Talnique",            boxful_city_id: "64a30324e16d1dbcc073b603" },
      { name: "Tamanique",           boxful_city_id: "64a30324e16d1dbcc073b604" },
      { name: "Teotepeque",          boxful_city_id: "64a30324e16d1dbcc073b605" },
      { name: "Tepecoyo",            boxful_city_id: "64a30324e16d1dbcc073b606" },
      { name: "Zaragoza",            boxful_city_id: "64a30324e16d1dbcc073b607" },
    ],
  },
  {
    name: "La Paz",
    boxful_state_id: "64a302eae2212e31584a819d",
    municipios: [
      { name: "Cuyultitán",              boxful_city_id: "64a30324e16d1dbcc073b608" },
      { name: "El Rosario",              boxful_city_id: "64a30324e16d1dbcc073b609" },
      { name: "Jerusalén",               boxful_city_id: "64a30324e16d1dbcc073b60a" },
      { name: "Mercedes La Ceiba",       boxful_city_id: "64a30324e16d1dbcc073b60b" },
      { name: "Olocuilta",               boxful_city_id: "64a30324e16d1dbcc073b60c" },
      { name: "Paraíso de Osorio",       boxful_city_id: "64a30324e16d1dbcc073b60d" },
      { name: "San Antonio Masahuat",    boxful_city_id: "64a30324e16d1dbcc073b60e" },
      { name: "San Emigdio",             boxful_city_id: "64a30324e16d1dbcc073b60f" },
      { name: "San Francisco Chinameca", boxful_city_id: "64a30324e16d1dbcc073b610" },
      { name: "San Juan Nonualco",       boxful_city_id: "64a30324e16d1dbcc073b611" },
      { name: "San Juan Talpa",          boxful_city_id: "64a30324e16d1dbcc073b612" },
      { name: "San Luis La Herradura",   boxful_city_id: "64a30324e16d1dbcc073b613" },
      { name: "San Luis Talpa",          boxful_city_id: "64a30324e16d1dbcc073b614" },
      { name: "San Miguel Tepezontes",   boxful_city_id: "64a30324e16d1dbcc073b615" },
      { name: "San Pedro Masahuat",      boxful_city_id: "64a30324e16d1dbcc073b616" },
      { name: "San Pedro Nonualco",      boxful_city_id: "64a30324e16d1dbcc073b617" },
      { name: "San Rafael Obrajuelo",    boxful_city_id: "64a30324e16d1dbcc073b618" },
      { name: "Santa María Ostuma",      boxful_city_id: "64a30324e16d1dbcc073b619" },
      { name: "Santiago Nonualco",       boxful_city_id: "64a30324e16d1dbcc073b61a" },
      { name: "Tapalhuaca",              boxful_city_id: "64a30324e16d1dbcc073b61b" },
      { name: "Zacatecoluca",            boxful_city_id: "64a30324e16d1dbcc073b61c" },
      { name: "San Juan Tepezontes",     boxful_city_id: "64a30324e16d1dbcc073b61d" },
    ],
  },
  {
    name: "La Unión",
    boxful_state_id: "64a302eae2212e31584a81a2",
    municipios: [
      { name: "Anamorós",              boxful_city_id: "64a30325e16d1dbcc073b6b7" },
      { name: "Bolívar",               boxful_city_id: "64a30325e16d1dbcc073b6b8" },
      { name: "Concepción de Oriente", boxful_city_id: "64a30325e16d1dbcc073b6b9" },
      { name: "Conchagua",             boxful_city_id: "64a30325e16d1dbcc073b6ba" },
      { name: "El Carmen",             boxful_city_id: "64a30325e16d1dbcc073b6bb" },
      { name: "El Sauce",              boxful_city_id: "64a30325e16d1dbcc073b6bc" },
      { name: "Intipucá",              boxful_city_id: "64a30325e16d1dbcc073b6bd" },
      { name: "La Unión",              boxful_city_id: "64a30325e16d1dbcc073b6be" },
      { name: "Lislique",              boxful_city_id: "64a30325e16d1dbcc073b6bf" },
      { name: "Meanguera del Golfo",   boxful_city_id: "64a30325e16d1dbcc073b6c0" },
      { name: "Nueva Esparta",         boxful_city_id: "64a30325e16d1dbcc073b6c1" },
      { name: "Pasaquina",             boxful_city_id: "64a30325e16d1dbcc073b6c2" },
      { name: "Polorós",               boxful_city_id: "64a30325e16d1dbcc073b6c3" },
      { name: "San Alejo",             boxful_city_id: "64a30325e16d1dbcc073b6c4" },
      { name: "San José",              boxful_city_id: "64a30325e16d1dbcc073b6c5" },
      { name: "Santa Rosa de Lima",    boxful_city_id: "64a30325e16d1dbcc073b6c6" },
      { name: "Yayantique",            boxful_city_id: "64a30325e16d1dbcc073b6c7" },
      { name: "Yucuaiquín",            boxful_city_id: "64a30325e16d1dbcc073b6c8" },
    ],
  },
  {
    name: "Morazán",
    boxful_state_id: "64a302eae2212e31584a81a0",
    municipios: [
      { name: "Arambala",               boxful_city_id: "64a30325e16d1dbcc073b66e" },
      { name: "Cacaopera",              boxful_city_id: "64a30325e16d1dbcc073b66f" },
      { name: "Chilanga",               boxful_city_id: "64a30325e16d1dbcc073b670" },
      { name: "Corinto",                boxful_city_id: "64a30325e16d1dbcc073b671" },
      { name: "Delicias de Concepción", boxful_city_id: "64a30325e16d1dbcc073b672" },
      { name: "El Divisadero",          boxful_city_id: "64a30325e16d1dbcc073b673" },
      { name: "El Rosario",             boxful_city_id: "64a30325e16d1dbcc073b674" },
      { name: "Gualococti",             boxful_city_id: "64a30325e16d1dbcc073b675" },
      { name: "Guatajiagua",            boxful_city_id: "64a30325e16d1dbcc073b676" },
      { name: "Joateca",                boxful_city_id: "64a30325e16d1dbcc073b677" },
      { name: "Jocoaitique",            boxful_city_id: "64a30325e16d1dbcc073b678" },
      { name: "Jocoro",                 boxful_city_id: "64a30325e16d1dbcc073b679" },
      { name: "Lolotiquillo",           boxful_city_id: "64a30325e16d1dbcc073b67a" },
      { name: "Meanguera",              boxful_city_id: "64a30325e16d1dbcc073b67b" },
      { name: "Osicala",                boxful_city_id: "64a30325e16d1dbcc073b67c" },
      { name: "Perquín",                boxful_city_id: "64a30325e16d1dbcc073b67d" },
      { name: "San Carlos",             boxful_city_id: "64a30325e16d1dbcc073b67e" },
      { name: "San Fernando",           boxful_city_id: "64a30325e16d1dbcc073b67f" },
      { name: "San Francisco Gotera",   boxful_city_id: "64a30325e16d1dbcc073b680" },
      { name: "San Isidro",             boxful_city_id: "64a30325e16d1dbcc073b681" },
      { name: "San Simón",              boxful_city_id: "64a30325e16d1dbcc073b682" },
      { name: "Sensembra",              boxful_city_id: "64a30325e16d1dbcc073b683" },
      { name: "Sociedad",               boxful_city_id: "64a30325e16d1dbcc073b684" },
      { name: "Torola",                 boxful_city_id: "64a30325e16d1dbcc073b685" },
      { name: "Yamabal",                boxful_city_id: "64a30325e16d1dbcc073b686" },
      { name: "Yoloaiquín",             boxful_city_id: "64a30325e16d1dbcc073b687" },
    ],
  },
  {
    name: "San Miguel",
    boxful_state_id: "64a302eae2212e31584a819f",
    municipios: [
      { name: "Carolina",               boxful_city_id: "64a30325e16d1dbcc073b641" },
      { name: "Chapeltique",            boxful_city_id: "64a30325e16d1dbcc073b642" },
      { name: "Chinameca",              boxful_city_id: "64a30325e16d1dbcc073b643" },
      { name: "Chirilagua",             boxful_city_id: "64a30325e16d1dbcc073b644" },
      { name: "Ciudad Barrios",         boxful_city_id: "64a30325e16d1dbcc073b645" },
      { name: "Comacarán",              boxful_city_id: "64a30325e16d1dbcc073b646" },
      { name: "El Tránsito",            boxful_city_id: "64a30325e16d1dbcc073b647" },
      { name: "Lolotique",              boxful_city_id: "64a30325e16d1dbcc073b648" },
      { name: "Moncagua",               boxful_city_id: "64a30325e16d1dbcc073b649" },
      { name: "Nueva Guadalupe",        boxful_city_id: "64a30325e16d1dbcc073b64a" },
      { name: "Nuevo Edén de San Juan", boxful_city_id: "64a30325e16d1dbcc073b64b" },
      { name: "Quelepa",                boxful_city_id: "64a30325e16d1dbcc073b64c" },
      { name: "San Antonio",            boxful_city_id: "64a30325e16d1dbcc073b63f" },
      { name: "San Gerardo",            boxful_city_id: "64a30325e16d1dbcc073b640" },
      { name: "San Jorge",              boxful_city_id: "64a30325e16d1dbcc073b63e" },
      { name: "San Luis de la Reina",   boxful_city_id: "64a30325e16d1dbcc073b63d" },
      { name: "San Miguel",             boxful_city_id: "64a30325e16d1dbcc073b63c" },
      { name: "San Rafael Oriente",     boxful_city_id: "64a30325e16d1dbcc073b63b" },
      { name: "Sesori",                 boxful_city_id: "64a30325e16d1dbcc073b63a" },
      { name: "Uluazapa",               boxful_city_id: "64a30325e16d1dbcc073b639" },
    ],
  },
  {
    name: "San Salvador",
    boxful_state_id: "64a302eae2212e31584a819f",
    municipios: [
      { name: "Aguilares",            boxful_city_id: "64a30323e16d1dbcc073b5f4" },
      { name: "Apopa",                boxful_city_id: "64a30323e16d1dbcc073b5f5" },
      { name: "Ayutuxtepeque",        boxful_city_id: "64a30323e16d1dbcc073b5f6" },
      { name: "Cuscatancingo",        boxful_city_id: "64a30323e16d1dbcc073b5f7" },
      { name: "Ciudad Delgado",       boxful_city_id: "64a30323e16d1dbcc073b5f8" },
      { name: "El Paisnal",           boxful_city_id: "64a30323e16d1dbcc073b5f9" },
      { name: "Guazapa",              boxful_city_id: "64a30323e16d1dbcc073b5fa" },
      { name: "Ilopango",             boxful_city_id: "64a30323e16d1dbcc073b5fb" },
      { name: "Mejicanos",            boxful_city_id: "64a30323e16d1dbcc073b5fc" },
      { name: "Nejapa",               boxful_city_id: "64a30323e16d1dbcc073b5fd" },
      { name: "Panchimalco",          boxful_city_id: "64a30323e16d1dbcc073b5fe" },
      { name: "Rosario de Mora",      boxful_city_id: "64a30323e16d1dbcc073b5ff" },
      { name: "San Marcos",           boxful_city_id: "64a30323e16d1dbcc073b600" },
      { name: "San Martín",           boxful_city_id: "64a30323e16d1dbcc073b601" },
      { name: "San Salvador",         boxful_city_id: "64a30323e16d1dbcc073b5e6" },
      { name: "Santiago Texacuangos", boxful_city_id: "64a30323e16d1dbcc073b602" },
      { name: "Santo Tomás",          boxful_city_id: "64a30323e16d1dbcc073b603" },
      { name: "Soyapango",            boxful_city_id: "64a30323e16d1dbcc073b604" },
      { name: "Tonacatepeque",        boxful_city_id: "64a30323e16d1dbcc073b605" },
    ],
  },
  {
    name: "San Vicente",
    boxful_state_id: "64a302eae2212e31584a819e",
    municipios: [
      { name: "Apastepeque",              boxful_city_id: "64a30324e16d1dbcc073b61e" },
      { name: "Guadalupe",                boxful_city_id: "64a30324e16d1dbcc073b61f" },
      { name: "San Cayetano Istepeque",   boxful_city_id: "64a30324e16d1dbcc073b620" },
      { name: "San Esteban Catarina",     boxful_city_id: "64a30324e16d1dbcc073b621" },
      { name: "San Ildefonso",            boxful_city_id: "64a30324e16d1dbcc073b622" },
      { name: "San Lorenzo",              boxful_city_id: "64a30324e16d1dbcc073b623" },
      { name: "San Sebastián",            boxful_city_id: "64a30324e16d1dbcc073b624" },
      { name: "San Vicente",              boxful_city_id: "64a30324e16d1dbcc073b625" },
      { name: "Santa Clara",              boxful_city_id: "64a30324e16d1dbcc073b626" },
      { name: "Santo Domingo",            boxful_city_id: "64a30324e16d1dbcc073b627" },
      { name: "Tecoluca",                 boxful_city_id: "64a30324e16d1dbcc073b628" },
      { name: "Tepetitán",                boxful_city_id: "64a30324e16d1dbcc073b629" },
      { name: "Verapaz",                  boxful_city_id: "64a30324e16d1dbcc073b62a" },
    ],
  },
  {
    name: "Santa Ana",
    boxful_state_id: "64a302e9e2212e31584a8196",
    municipios: [
      { name: "Candelaria de la Frontera",  boxful_city_id: "64a30322e16d1dbcc073b5a9" },
      { name: "Chalchuapa",                 boxful_city_id: "64a30322e16d1dbcc073b5aa" },
      { name: "Coatepeque",                 boxful_city_id: "64a30322e16d1dbcc073b5ab" },
      { name: "El Congo",                   boxful_city_id: "64a30322e16d1dbcc073b5ac" },
      { name: "El Porvenir",                boxful_city_id: "64a30322e16d1dbcc073b5ad" },
      { name: "Masahuat",                   boxful_city_id: "64a30322e16d1dbcc073b5ae" },
      { name: "Metapán",                    boxful_city_id: "64a30322e16d1dbcc073b5af" },
      { name: "San Antonio Pajonal",        boxful_city_id: "64a30322e16d1dbcc073b5b0" },
      { name: "San Sebastián Salitrillo",   boxful_city_id: "64a30322e16d1dbcc073b5b1" },
      { name: "Santa Ana",                  boxful_city_id: "64a30322e16d1dbcc073b5a8" },
      { name: "Santa Rosa Guachipilín",     boxful_city_id: "64a30322e16d1dbcc073b5b2" },
      { name: "Santiago de la Frontera",    boxful_city_id: "64a30322e16d1dbcc073b5b3" },
      { name: "Texistepeque",               boxful_city_id: "64a30322e16d1dbcc073b5b4" },
    ],
  },
  {
    name: "Sonsonate",
    boxful_state_id: "64a302e9e2212e31584a819a",
    municipios: [
      { name: "Acajutla",                  boxful_city_id: "64a30324e16d1dbcc073b64d" },
      { name: "Armenia",                   boxful_city_id: "64a30324e16d1dbcc073b650" },
      { name: "Caluco",                    boxful_city_id: "64a30324e16d1dbcc073b651" },
      { name: "Cuisnahuat",                boxful_city_id: "64a30324e16d1dbcc073b64e" },
      { name: "Izalco",                    boxful_city_id: "64a30324e16d1dbcc073b653" },
      { name: "Juayúa",                    boxful_city_id: "64a30324e16d1dbcc073b652" },
      { name: "Nahuizalco",                boxful_city_id: "64a30324e16d1dbcc073b654" },
      { name: "Nahulingo",                 boxful_city_id: "64a30324e16d1dbcc073b64f" },
      { name: "Salcoatitán",               boxful_city_id: "64a30324e16d1dbcc073b655" },
      { name: "San Antonio del Monte",     boxful_city_id: "64a30324e16d1dbcc073b656" },
      { name: "San Julián",                boxful_city_id: "64a30324e16d1dbcc073b657" },
      { name: "Santa Catarina Masahuat",   boxful_city_id: "64a30324e16d1dbcc073b658" },
      { name: "Santa Isabel Ishuatán",     boxful_city_id: "64a30324e16d1dbcc073b65a" },
      { name: "Santo Domingo de Guzmán",   boxful_city_id: "64a30324e16d1dbcc073b659" },
      { name: "Sonsonate",                 boxful_city_id: "64a30324e16d1dbcc073b65b" },
      { name: "Sonzacate",                 boxful_city_id: "64a30324e16d1dbcc073b65d" },
    ],
  },
  {
    name: "Usulután",
    boxful_state_id: "64a302eae2212e31584a819b",
    municipios: [
      { name: "Alegría",              boxful_city_id: "64a30324e16d1dbcc073b628" },
      { name: "Berlín",               boxful_city_id: "64a30324e16d1dbcc073b62b" },
      { name: "California",           boxful_city_id: "64a30324e16d1dbcc073b629" },
      { name: "Concepción Batres",    boxful_city_id: "64a30324e16d1dbcc073b62a" },
      { name: "El Triunfo",           boxful_city_id: "64a30324e16d1dbcc073b62e" },
      { name: "Ereguayquín",          boxful_city_id: "64a30324e16d1dbcc073b62d" },
      { name: "Estanzuelas",          boxful_city_id: "64a30324e16d1dbcc073b62f" },
      { name: "Jiquilisco",           boxful_city_id: "64a30324e16d1dbcc073b630" },
      { name: "Jucuapa",              boxful_city_id: "64a30324e16d1dbcc073b632" },
      { name: "Jucuarán",             boxful_city_id: "64a30324e16d1dbcc073b633" },
      { name: "Mercedes Umaña",       boxful_city_id: "64a30324e16d1dbcc073b631" },
      { name: "Nueva Granada",        boxful_city_id: "64a30324e16d1dbcc073b637" },
      { name: "Ozatlán",              boxful_city_id: "64a30324e16d1dbcc073b638" },
      { name: "Puerto El Triunfo",    boxful_city_id: "64a30324e16d1dbcc073b635" },
      { name: "San Agustín",          boxful_city_id: "64a30324e16d1dbcc073b636" },
      { name: "San Buenaventura",     boxful_city_id: "64a30324e16d1dbcc073b634" },
      { name: "San Dionisio",         boxful_city_id: "64a30324e16d1dbcc073b63b" },
      { name: "San Francisco Javier", boxful_city_id: "64a30324e16d1dbcc073b63f" },
      { name: "Santa Elena",          boxful_city_id: "64a30324e16d1dbcc073b639" },
      { name: "Santa María",          boxful_city_id: "64a30324e16d1dbcc073b63a" },
      { name: "Santiago de María",    boxful_city_id: "64a30324e16d1dbcc073b63e" },
      { name: "Tecapán",              boxful_city_id: "64a30324e16d1dbcc073b63c" },
      { name: "Usulután",             boxful_city_id: "64a30324e16d1dbcc073b63d" },
    ],
  },
];
